import React from 'react';
import { H5 } from '@spark/ui-components/components/Typography'; // Cabeçalho padrão da listagem

const NotificacoesHeader = ({
  totalRegistros
}) => {
  return <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16
  }}>
      <H5>Notificações</H5>
      <div style={{
      color: '#6c757d',
      fontSize: 14
    }}>Total: {totalRegistros || 0}</div>
    </div>;
};

export default NotificacoesHeader;